import { useParams } from "react-router-dom";
import { useCentralStore } from "../../store/Central";
import { useJobStore } from "../../store/Jobs";
import { useMemo } from "react";
import { ChatComponent } from "../../components/chat/chat.component";
import { useRealtimeStore } from "@/lib/store/Realtime";
import { ChannelType } from "@/lib/store/Realtime/message.store";

export const ClientGeneralChatPage: React.FC = () => {
    const { clientId } = useParams();
    
    const { organization, clients } =
        useCentralStore((state) => ({
            organization: state.organization,
            userId: state.profile?.id,
            clients: Object.values(state.clientsLookup),
        }));
    const { shareFile, unshareFile, acceptJobRequest, denyJobRequest } =
        useJobStore((state) => ({
            shareFile: state.shareFile,
            unshareFile: state.unshareFile,
            acceptJobRequest: state.acceptJobRequest,
            denyJobRequest: state.denyJobRequest,
        }));

    const { latestChannels } = useRealtimeStore((state) => ({
        latestChannels: state.latestChannels,
    }));

    const customerOrganizationId = useMemo(() => {
        return clients.find((client) => client.id === clientId)?.connected_organization_id;
    }, [clientId, clients]);

    const channelId = useMemo(() => {
        if (!customerOrganizationId) {
            return null;
        }

        return latestChannels.find((channel) => channel.customer_org_id === customerOrganizationId && channel.channel_type === ChannelType.GENERAL)?.id ?? null;
    }, [latestChannels, customerOrganizationId]);

    if (!channelId || !organization?.id || !customerOrganizationId) {
        return <div></div>;
    }

    return (
        <div className="h-full w-full">
            <ChatComponent
                organizationId={organization?.id}
                channelId={channelId}
                onShareFile={shareFile}
                onUnshareFile={unshareFile}
                onAcceptJobRequest={acceptJobRequest}
                onDenyJobRequest={denyJobRequest}
                clientOrganizationIds={[customerOrganizationId]}
                allowGoTo={true}
                checkForClientConnectionToCustomer={false}
            />
        </div>
    );
}